App.Views.MassiveSmartGeocode = {

    buildGridHeader: function () {
        const gridHeader = document.createElement('div');
        gridHeader.id = 'grid_header';

        const gridHeaderLeft = document.createElement('div');
        gridHeaderLeft.className = 'grid_header__left';

        const gridHeaderRight = document.createElement('div');
        gridHeaderRight.className = 'grid_header__rigth';

        const reviewFilters = document.createElement('a');
        reviewFilters.innerText = Monet.I18n.getResourcesByKey('SmartGeocode.grid.reviewFilters');

        reviewFilters.onclick = () => {
            App.Objects.MassiveSmartGeocode.goToScreen('form');
        };

        gridHeaderLeft.appendChild(reviewFilters);

        gridHeader.appendChild(gridHeaderLeft);
        gridHeader.appendChild(gridHeaderRight);

        return gridHeader;
    },

    removeGridActions: function () {
        const gridActions = document.querySelector('#SmartGeocode .gridActions');
        const actionDivs = gridActions.querySelectorAll('.gridActionDiv');
        const popupCustomizeColumns = gridActions.querySelector(".MonetUIGridActionsButton");
        const popupExportFormats = gridActions.querySelector(".popupExportFormats");

        if (actionDivs.length) {
            actionDivs.forEach((actionDiv) => {
                const parent = actionDiv.parentNode;
                parent.removeChild(actionDiv);
            });
        }

        if (popupCustomizeColumns) {
            const parent = popupCustomizeColumns.parentNode;
            parent.removeChild(popupCustomizeColumns);
        }

        if (popupExportFormats) {
            const parent = popupExportFormats.parentNode;
            parent.removeChild(popupExportFormats);
        }
    },

    showGrid: function () {
        const grid = new Greenmile.MassiveSmartGeocode.Grid();
        const dataMapper = new Monet.Builder.DataMapper();

        const callback = () => {
            this.changeTheTypesOfFiltersFields();
            this.removeGridActions();
            grid.show();
        };

        dataMapper.setEntity('MassiveSmartGeocode');
        dataMapper.build(callback);
    },

    showProgressBar: function (status, notify) {
        const progressBar = new Greenmile.MassiveSmartGeocode.ProgressBar('#SmartGeocode', notify);
        const router = App.Objects.MassiveSmartGeocode;

        const finishedCallback = () => {
            router.goToScreen('grid');
        };

        const updateCallback = () => {
            if (progressBar.isRendered()) {
                setTimeout(() => router.updateProgress(updateCallback, finishedCallback), 5000);
            }
        };

        progressBar.showPopupAndUpdate(status);

        updateCallback();
    },

    showForm: function (options) {
        const form = new Greenmile.MassiveSmartGeocode.Form();
        form.renderForm(options);
    },

    showMap: function (locationId) {
        App.Objects.MassiveSmartGeocode.goToScreen('map', { locationId });
    },

    toogleSpinnerLoadingInBtn: function(button) {
        button.disabled = !button.disabled;
        button.classList && button.classList.toggle("loader-spinner");
    },

    showLoadingAndDisableButtons: function () {
        const container = document.querySelector('#SmartGeocode');

        const buttons = container.querySelectorAll('.buttonsContainer input.button');
        buttons.forEach((button) => {
            this.toogleSpinnerLoadingInBtn(button);
        });

        Greenmile.MassiveSmartGeocode.isProcessingAccept = true;
    },

    hideLoadingAndEnableButtons: function () {
        const buttons = document.querySelectorAll('#SmartGeocode .buttonsContainer input.button');
        Greenmile.MassiveSmartGeocode.isProcessingAccept = false;
        
        if (buttons) {
            buttons.forEach((button) => {
                this.toogleSpinnerLoadingInBtn(button);
            });
            
            return true;
        }

        return false;
    },

    showMapAndDetailSmartGeocode: function (data) {
        const location = data.location;
        const detailSmartGeocode = new Greenmile.MassiveSmartGeocode.Map(data.id, data.processId, data.location.id);
        const map = detailSmartGeocode.createMap();
        const suggestedPosition = { latitude: data.proposedLat, longitude: data.proposedLong };
        const lineColor = '#3BB0E0';

        detailSmartGeocode.addSuggestedMarker(suggestedPosition, map, location);
        detailSmartGeocode.addCurrentMarker(location, map);

        Greenmile.Map.Utility.drawLine([location.latitude, location.longitude], [suggestedPosition.latitude, suggestedPosition.longitude], lineColor, map);

        detailSmartGeocode.addEventListener();

        const selector = "#SmartGeocode #mapToolbar";
        const mapBase = Greenmile.MassiveSmartGeocode.mapBaseLayer;

        Greenmile.MassiveSmartGeocode.map = map;

        const options = {
            screenRoute: {
                mapBaseLayer: mapBase
            }
        };
        const helper = new Monet.UI.Help('SmartGeocodeDetail', Monet.I18n.getResourcesByKey('SmartGeocode.title'));
        const toolbar = new Greenmile.Toolbar.Map(map, selector, options, helper);

        toolbar.enable([
            toolbar.actions.searchAddressOnMap,
            toolbar.actions.points,
            toolbar.actions.street,
            toolbar.actions.zoom,
            toolbar.actions.source,
            toolbar.actions.fitToMarkers
        ]);

        toolbar.render();

    },

    changeTheTypesOfFiltersFields: function () {
        const fields = App.Forms?.MassiveSmartGeocode?.fields;
        const fieldsToChangeTheTypeToDecimal = ['confidence', 'locationsDistance'];
        const fieldsToChangeTheTypeToLatLong = ['proposedLat', 'proposedLong'];
        const fieldsToChangeTheTypeToNumber = ['totalStops', 'validStops'];
        const fieldsToChangeTheTypeToDate = ['location.geocodingDate', 'location.geocodingLastCheck'];

        const executeChangeFieldsTo = (list, typeToChange) => {
            list.forEach( fieldName => {
                if(fields && fields[fieldName] && fields[fieldName].type) {
                    fields[fieldName].type = typeToChange;
                } else {
                    new Monet.Exception.ReturnError(
                        this, 
                        `Error when tried to change the TYPE of the ${fieldName}. Maybe his name was changed.`
                    )
                    .console();
                }
            });
        };

        executeChangeFieldsTo(fieldsToChangeTheTypeToDecimal, "DECIMAL");
        executeChangeFieldsTo(fieldsToChangeTheTypeToLatLong, "LAT_LONG");
        executeChangeFieldsTo(fieldsToChangeTheTypeToNumber, "INTEGER");
        executeChangeFieldsTo(fieldsToChangeTheTypeToDate, "DATE");

    },
};
